import { useQuery } from 'react-query'

import { PortalName } from 'commons/types/enums'
import { Request } from 'commons/utils/request'

import { selector } from './components/DeviceTable/selector'

const urls = {
  [PortalName.BP]: Request.urls.bank.deviceList,
  [PortalName.CP]: Request.urls.client.deviceList,
  [PortalName.BOP]: Request.urls.support.deviceList
}

export const useDeviceList = (portal: PortalName) => {
  const {
    data,
    isFetching,
    refetch: reloadDeviceList
  } = useQuery({
    queryFn: () =>
      Request.post(urls[portal], {
        _options: {
          orders: [
            {
              field: 'id',
              direction: 'DESC'
            }
          ],
          onChange: () => ({})
        }
      }),
    queryKey: ['mfa-devices']
  })

  const dataSource = data ? selector(data) : []

  return {
    isFetching,
    dataSource,
    reloadDeviceList
  }
}
